import { Modal, Button } from 'antd';
import { WarningFilled } from '@ant-design/icons';

interface Props {
  open: boolean;
  companyMax?: number | string;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  badgeLabel?: string;
  okText?: string;
  cancelText?: string;
  width?: number;
}


export default function MaxInstallmentsWarningModal({
  open,
  companyMax,
  onConfirm,
  onCancel,
  title = 'Maximum Installments Warning',
  message = 'You are giving this user more than the maximum number of installments allowed for his company.',
  badgeLabel = 'Company Max Installment Count',
  okText = 'Yes, proceed',
  cancelText = 'Cancel',
  width = 460,
}: Props) {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      width={width}
      wrapClassName="cu-warning-wrap"
      className="cu-warning-modal"
      onCancel={onCancel}
    >
      <div className="cu-warning">
        <div className="cu-warning-glow" />
        <div className="cu-warning-icon">
          <WarningFilled />
        </div>
        <h3 className="cu-warning-title">{title}</h3>
        <p className="cu-warning-text">{message}</p>
        {(companyMax !== undefined && companyMax !== null && companyMax !== '') && (
          <div className="cu-warning-badge">
            <span className="cu-warning-badge-label">{badgeLabel}</span>
            <span className="cu-warning-badge-value">{companyMax}</span>
          </div>
        )}
        <p className="cu-warning-question">Are you sure you want to proceed?</p>
        <div className="cu-warning-actions">
          <Button className="cu-warning-cancel" shape="round" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button className="cu-warning-confirm" type="primary" shape="round" onClick={onConfirm}>
            {okText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
